export const OPCOES_LOCAL_ATENDIMENTO = [
  { value: "SEDE", label: "Sede" },
  { value: "DOMICILIO", label: "Domicílio" },
];

export const OPCOES_MEDICACAO_ORIGEM = [
  { value: "CLIENTE", label: "Cliente" },
  { value: "DNA_CARE", label: "DNA Care" },
];

export const OPCOES_PAGAMENTO_STATUS = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "EFETUADO", label: "Efetuado" },
];
